<template>
  <div class="module-properties">
    <div class="form-group">
      <label>Tipo de Validação</label>
      <select v-model="config.validationType">
        <option value="completeness">Completude</option>
        <option value="uniqueness">Unicidade</option>
        <option value="consistency">Consistência</option>
        <option value="accuracy">Precisão</option>
      </select>
    </div>
    
    <div class="form-group">
      <label>Campo</label>
      <input type="text" v-model="config.field" placeholder="Nome do campo">
    </div>
    
    <div class="form-group" v-if="config.validationType === 'completeness'">
      <label>Percentual Mínimo</label>
      <input type="number" v-model="config.minPercentage" min="0" max="100" placeholder="Ex: 95">
    </div>
    
    <div class="form-group" v-if="config.validationType === 'uniqueness'">
      <label>Permitir Duplicados</label>
      <input type="checkbox" v-model="config.allowDuplicates">
    </div>
    
    <div class="form-group" v-if="config.validationType === 'consistency'">
      <label>Regra de Validação</label>
      <input type="text" v-model="config.validationRule" placeholder="Ex: campo1 > 0">
    </div>
    
    <div class="form-group" v-if="config.validationType === 'accuracy'">
      <label>Valor de Referência</label>
      <input type="text" v-model="config.referenceValue" placeholder="Valor esperado">
    </div>
    
    <div class="form-group">
      <label>Ação em Caso de Falha</label>
      <select v-model="config.failureAction">
        <option value="log">Apenas Registrar</option>
        <option value="flag">Marcar Registros</option>
        <option value="filter">Filtrar Registros</option>
        <option value="stop">Parar Execução</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataQualityModuleProperties',
  props: {
    module: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      config: {
        validationType: 'completeness',
        field: '',
        minPercentage: 95,
        allowDuplicates: false,
        validationRule: '',
        referenceValue: '',
        failureAction: 'log',
        ...this.module.config
      }
    };
  },
  watch: {
    config: {
      handler(newConfig) {
        this.$emit('update:config', newConfig);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.module-properties {
  padding: 10px;
}
.form-group {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
select, input[type="text"], input[type="number"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
